export function isTaskAllowed(task, taskList) {
    if(taskList){
        let filteredTask = taskList?.filter((item) => {return item.title === task});
        return filteredTask[0]?.isAssigned;
    }
    return false;
}